import { IAppState } from '../../../AppModulesWrapper';

export const selectIsMultiPostingEnabled = (state: IAppState) =>
  Boolean(state.servicePickerWidget.offer.multiposting ? state.servicePickerWidget.offer.multiposting.enabled : false);
